import React, { Fragment } from "react";
import { Formik } from "formik";
import Select from "react-select";
import PageTitle from "../../layouts/PageTitle";
import { create, updateAction } from "../../../store/actions/CommonActions";
import CustomTextarea from "../../components/Forms/CustomInputs/CustomTextarea";
import { initiativeValidationSchema } from "../../../utils/validationSchemas/MasterDataSchema";
import CustomDropdown from "../../components/Forms/CustomInputs/CustomDropdown";
import { useSelector } from "react-redux";
import CustomImageUpload from "../../components/Forms/CustomInputs/CustomImageUpload";

const AddUpdateUI = ({
  state,
  initialValues,
  handleFormSubmit,
  selectedCity,
  setSelectedCity,
  selectedCurator,
  setSelectedCurator,
}) => {
  const { data: cities } = useSelector((state) => state.city);
  const { data: curators } = useSelector((state) => state.users);
  return (
    <Fragment>
      <PageTitle />

      <div className="row">
        <div className="col-lg-6">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">
                {state?._id ? "Edit" : "Add New"} Initiative
              </h4>
            </div>
            <div className="card-body">
              <div className="basic-form">
                <Formik
                  initialValues={initialValues}
                  validationSchema={initiativeValidationSchema}
                  onSubmit={handleFormSubmit}
                >
                  {({
                    values,
                    errors,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                    touched,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div
                          className={`form-group col-md-12 mb-3 ${
                            errors.title ? "is-invalid" : "is-valid"
                          }`}
                        >
                          <label className="text-label">
                            Name of the Initiative
                          </label>
                          <input
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.title}
                            className="input form-control"
                            name="title"
                          />
                          {errors.title && (
                            <div
                              id="val-title-error"
                              class="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            >
                              {errors.title}
                            </div>
                          )}
                        </div>

                        <div
                          className={`form-group col-md-12 mb-3 ${
                            errors.edition ? "is-invalid" : "is-valid"
                          }`}
                        >
                          <label className="text-label">Edition</label>
                          <input
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.edition}
                            className="input form-control"
                            name="edition"
                          />
                          {errors.edition && (
                            <div
                              id="val-edition-error"
                              class="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            >
                              {errors.edition}
                            </div>
                          )}
                        </div>

                        <div
                          className={`form-group col-md-6 mb-3 ${
                            errors.city ? "is-invalid" : "is-valid"
                          }`}
                        >
                          <label className="text-label">Start Date</label>
                          <input
                            type="date"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={
                              values.start_date
                                ? new Date(values.start_date)
                                    .toISOString()
                                    .slice(0, 10)
                                : ""
                            }
                            className="input form-control"
                            name="start_date"
                            max={
                              values.end_date
                                ? new Date(values.end_date)
                                    .toISOString()
                                    .slice(0, 10)
                                : undefined
                            }
                          />
                          {errors.start_date && (
                            <div
                              id="val-start_date-error"
                              class="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            >
                              {errors.start_date}
                            </div>
                          )}
                        </div>

                        <div
                          className={`form-group col-md-6 mb-3 ${
                            errors.end_date ? "is-invalid" : "is-valid"
                          }`}
                        >
                          <label className="text-label">End Date</label>
                          <input
                            type="date"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={
                              values.end_date
                                ? new Date(values.end_date)
                                    .toISOString()
                                    .slice(0, 10)
                                : ""
                            }
                            className="input form-control"
                            name="end_date"
                            min={
                              values.start_date
                                ? new Date(values.start_date)
                                    .toISOString()
                                    .slice(0, 10)
                                : undefined
                            }
                          />
                          {errors.end_date && (
                            <div
                              id="val-end_date-error"
                              class="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            >
                              {errors.end_date}
                            </div>
                          )}
                        </div>

                        <CustomDropdown
                          fieldName="city"
                          values={selectedCity}
                          error={errors.city}
                          label={"City"}
                          classes={"col-md-6"}
                          setFieldValue={setFieldValue}
                          handleChange={(value) => setSelectedCity(value)}
                          options={
                            cities
                              ? cities?.map((data) => {
                                  return { label: data.name, value: data._id };
                                })
                              : []
                          }
                        />

                        <CustomDropdown
                          fieldName="curator"
                          values={selectedCurator}
                          error={errors.curator}
                          label={"Initiative Lead"}
                          classes={"col-md-6 z-3"}
                          setFieldValue={setFieldValue}
                          handleChange={(value) => setSelectedCurator(value)}
                          options={
                            curators
                              ? curators?.map((data) => {
                                  return {
                                    label: `${data.firstname} ${data.lastname}`,
                                    value: data._id,
                                  };
                                })
                              : []
                          }
                        />

                        <CustomImageUpload
                          fieldName="banner"
                          value={values.banner}
                          error={errors.banner}
                          label={
                            "Upload Cover Image (16:9 / e.g. 800px X 450px)"
                          }
                          classes={"col-md-12"}
                          handleBlur={handleBlur}
                          inputType={"text"}
                          handleChange={handleChange}
                          setFieldValue={setFieldValue}
                        />
                        <CustomTextarea
                          errors={errors}
                          setFieldValue={setFieldValue}
                          handleBlur={handleBlur}
                          values={values}
                          touched={touched}
                        />
                      </div>

                      <div className="float-end">
                        <button
                          type="submit"
                          className="btn me-2 btn-primary"
                          disabled={isSubmitting}
                        >
                          Save
                        </button>
                      </div>
                      {/* <button className="btn btn-danger light">Cancel</button> */}
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddUpdateUI;
